<div class="c-gp-sponsorship">
	<div class="payment-type-select">
		<input id="switch-payment-type"
			type="checkbox"
			aria-checked="{{oneTimeChecked}}"
			checked="{{oneTimeChecked}}"
			twoway="false"
			class="switch-input {{#if oneTimeChecked}} checked {{/if}}"
			on-click="@this.handlePaymentTypeInputClick(@event)"
			on-keydown="@this.handlePaymentTypeInputKeyDown(@event)">

		<label for="switch-payment-type" on-click="@this.handlePaymentTypeLabelClick(@event)">
			<span class="prevent-select" on-click="@this.handlePaymentTypeSwitch(false)">Monthly</span>
			<span class="prevent-select" on-click="@this.handlePaymentTypeSwitch(true)">One-time</span>
		</label>
	</div>

	<div class="donation">
		<label for="slider" class="sponsorship-subtitle">Donation amount:</label>
		<input id="slider" type="range" min="{{sliderMinimum}}" max="{{sliderMaximum}}" step="0.001" value="{{sliderValue}}" class="slider" on-input="@this.roundSliderValue()" on-keydown="@this.handleSliderKeypress(@event)">
		<div class="slider-overlay">
			<div class="slider-overlay_track" style-width="calc({{sliderPosition * 100}}% + {{(1/2 - sliderPosition) * 15}}px)"></div>
			<span class="slider-overlay_label" style-margin-left="calc({{sliderPosition * 100}}% + {{(1/2 - sliderPosition) * 15}}px)">${{toDonate}}</span>
		</div>
	</div>

	{{#if showHighVolumeDiscount}}
		<div class="volume-discount">
			<img width="22" height="22" src="{{@shared.assetsHost}}/img/mail-icon.svg" alt="">
			<p>Higher volume discounts available! If you expect to spend more than $3000 per month, please <a href="mailto:d@globalping.io">get in touch</a> to discuss individual pricing.</p>
		</div>
	{{/if}}

	{{#if oneTimeChecked}}
		<div class="one-time-donation">
			<div class="donation-information">
				<div class="donation-information_block">
					<span>{{#if !isLoggedIn}}Estimated{{/if}} Bonus:</span>
					<span class="donation-information_value">+{{@this.formatNumber(estimatedBonus)}}%</span>

					<span>Credits Total:</span>
					<span class="donation-information_value">{{@this.formatNumber(creditsTotal)}}</span>
				</div>
				<p class="donation-information_footer">
					{{#if isLoggedIn}}
						{{#if donatedLastYear && estimatedBonus > 0}}
							(Total bonus based on your personal donation history)
						{{/if}}
					{{else}}
						(Assuming this is your first donation)
					{{/if}}
				</p>
			</div>

			{{#if !isLoggedIn}}
			<p>
				<a class="sign-in-link" href="{{@global.app.getSignInLink()}}">Sign in</a> to calculate your personal bonus based on past donations.
			</p>
			{{/if}}

			<a class="gp_btn_green button-link" href="{{@this.getOneTimeDonationLink(toDonate)}}" target="_blank">
				Donate
			</a>
		</div>
	{{else}}
		<div class="monthly-donation">
			<div class="monthly-donation_information">
				<p>Your bonus grows as your total donations increase.</p>

				{{#if !isLoggedIn || !donatedLastYear}}
					<p>At ${{toDonate}}/month, your bonus increases {{#if bonusIncreasePeriod === 1}}{{#if !isBonusPeriodExact}}almost{{/if}} every month{{else}}every {{#if !isBonusPeriodExact}}~{{/if}}{{bonusIncreasePeriod}} months{{/if}}, up to {{maxTwelveMonthBonus}}% in month {{monthMaximumReached}}.</p>
				{{else}}
					<p>At ${{toDonate}}/month, your bonus stabilizes at {{maxTwelveMonthBonus}}% in month {{monthMaximumReached}}.</p>
				{{/if}}

				<p>From month {{monthMaximumReached}} onward, each monthly donation earns {{@this.formatNumber(lastMonthlyDonationCredits)}} credits.</p>

				{{#if isLoggedIn}}
					{{#if donatedLastYear && estimatedBonus > 0}}
						<p class="monthly-donation_information_footer">(Bonus based on your personal donation history)</p>
					{{/if}}
				{{else}}
					<p class="monthly-donation_information_footer">(Assuming this is your first donation)</p>
				{{/if}}
			</div>

			<h3 class="sponsorship-subtitle">Monthly bonus progress</h3>
			<div class="monthly-donation_infographic">
				{{#each Array(13): index}}
					{{#if skipMiddleMonths && index+1 >= 5 && index+1 <= 9}}
						<span class="skipped-month"></span>
					{{else}}
						<div class="infographic-cell">
							<div class="bonus-percentage {{#if @this.isMonthIncrease(index + 1)}} bonus-highlight {{/if}} {{#if index === 12}} final-cell {{/if}}">
								{{@this.formatNumber(subscriptionBonuses[index])}}%
							</div>
							<div >
								{{#if index === 12}}
								<span class="mobile-only">Ongoing</span>...
								{{else}}
								M<span class="mobile-only">onth </span>{{index+1}}
								{{/if}}
							</div>
						</div>
					{{/if}}
				{{/each}}
			</div>

			<div class="prepay-subscription">
				<img width="48" height="48" src="{{@shared.assetsHost}}/img/bulb-icon-big.svg">

				<div>
					<h4>
						Prepay 12 months & get full bonus instantly!
					</h4>
					<p>
						Credits: {{@this.formatNumber(twelveMonthCredits)}}
					</p>
				</div>

				<a class="gp_btn_green get-now-button button-link" href="{{@this.getOneTimeDonationLink(12 * toDonate)}}" target="_blank">
					Get now
				</a>
			</div>

			{{#if !isLoggedIn}}
			<p>
				<a class="sign-in-link" href="{{@global.app.getSignInLink()}}">Sign in</a> to calculate your personal bonus based on past donations.
			</p>
			{{/if}}

			<a class="gp_btn_black button-link" href="https://github.com/sponsors/jsdelivr?frequency=recurring&amount={{toDonate}}" target="_blank">
				Start Monthly Support
			</a>
		</div>
	{{/if}}
</div>

<script>
	const _ = require('../../assets/js/_');
	const http = require('../../assets/js/utils/http');
	const listeners = require('../../assets/js/utils/listeners');

	const MAXIMUM_BONUS = 1500; // in %
	const DOLLARS_FOR_BONUS = 100; // dollars needed for bonus increase
	const CREDITS_PER_DOLLAR = 4000;
	const BONUS_PER_HUNDRED_DOLLARS = 5;
	const MAXIMUM_ONE_TIME_DONATION = 12000;

	component.exports = {
		data () {
			return {
				isMobileScreen: false,
				oneTimeChecked: false,
				sliderValue: 10,
				donatedLastYear: 0,
				donatedByMonth: Array(12).fill(0),
			};
		},
		computed: {
			minimumDonation () {
				if (this.get('oneTimeChecked')) {
					return 5;
				}

				return 10;
			},
			maximumDonation () {
				if (this.get('oneTimeChecked')) {
					return 60000;
				}

				return 6000;
			},
			sliderMinimum () {
				return Math.sqrt(this.get('minimumDonation'));
			},
			sliderMaximum () {
				return Math.sqrt(this.get('maximumDonation'));
			},
			sliderPosition () {
				let sliderValue = this.get('sliderValue');
				let sliderMinimum = this.get('sliderMinimum');
				let sliderMaximum = this.get('sliderMaximum');

				return (sliderValue - sliderMinimum) / (sliderMaximum - sliderMinimum);
			},
			toDonate () {
				return Math.round(Math.pow(this.get('sliderValue'), 2) / 5) * 5;
			},
			estimatedBonus () {
				let totalDonated = this.get('donatedLastYear') + this.get('toDonate');
				let bonusSize = Math.floor(totalDonated / DOLLARS_FOR_BONUS) * BONUS_PER_HUNDRED_DOLLARS;

				return Math.min(bonusSize, MAXIMUM_BONUS);
			},
			creditsTotal () {
				let rawCredits = CREDITS_PER_DOLLAR * this.get('toDonate');

				return Math.round((this.get('estimatedBonus') / 100 + 1) * rawCredits);
			},
			bonusIncreasePeriod () {
				return Math.max(Math.round(DOLLARS_FOR_BONUS / this.get('toDonate')), 1);
			},
			isBonusPeriodExact () {
				return this.get('toDonate') >= 100 || DOLLARS_FOR_BONUS % this.get('toDonate') === 0;
			},
			subscriptionBonuses () {
				return Array.from({ length: 13 }, (_, index) => {
					let month = Math.min(index + 1, 12);
					let previousDonations = this.get('donatedByMonth').slice(month, 12).reduce((a, b) => a + b, 0);
					let bonusLevel = Math.floor((Math.min(month, 12) * this.get('toDonate') + previousDonations) / DOLLARS_FOR_BONUS);
					return Math.min(bonusLevel * BONUS_PER_HUNDRED_DOLLARS, MAXIMUM_BONUS);
				});
			},
			maxTwelveMonthBonus () {
				return Math.min(Math.floor(this.get('toDonate') * 12 / DOLLARS_FOR_BONUS) * BONUS_PER_HUNDRED_DOLLARS, MAXIMUM_BONUS);
			},
			monthMaximumReached () {
				let dollarsForMaxBonus = MAXIMUM_BONUS * DOLLARS_FOR_BONUS / BONUS_PER_HUNDRED_DOLLARS;
				return Math.min(Math.floor(dollarsForMaxBonus / this.get('toDonate')), 12);
			},
			twelveMonthCredits () {
				let rawCredits = this.get('toDonate') * 12 * CREDITS_PER_DOLLAR;
				return Math.round((1 + this.get('maxTwelveMonthBonus') / 100) * rawCredits / 1000) * 1000;
			},
			lastMonthlyDonationCredits () {
				let rawCredits = this.get('toDonate') * CREDITS_PER_DOLLAR;
				return Math.round((1 + this.get('maxTwelveMonthBonus') / 100) * rawCredits / 1000) * 1000;
			},
			showHighVolumeDiscount () {
				return this.get('toDonate') >= 3000;
			},
			isLoggedIn () {
				return !!this.get('@shared.user');
			},
			skipMiddleMonths () {
				return !this.get('isMobileScreen') && this.get('subscriptionBonuses')[8] >= 100;
			},
		},
		observe: {
			'@shared.user' (user) {
				if (!user?.id) {
					this.set('donatedLastYear', 0);
					this.set('donatedByMonth', Array(12).fill(0));
					return;
				}

				http.getSponsorshipDetails(user.id).then((response) => {
					if (response?.donatedInLastYear) {
						this.set('donatedLastYear', response.donatedInLastYear);
					}

					if (response?.donatedByMonth?.length === 12) {
						this.set('donatedByMonth', response.donatedByMonth);
					}
				}).catch((e) => {
					console.error(e);
				});
			},
			'oneTimeChecked' () {
				if (this.get('oneTimeChecked')) {
					this.set('sliderValue', 10);
					return;
				}

				this.set('sliderValue', 5);
			},
			'screenWidth' () {
				this.set('isMobileScreen', _.isMobileScreen() || _.isTabletScreen());
			},
		},
		oncomplete () {
			if (!Ractive.isServer) {
				// reset slider when navigating back to the page
				setTimeout(() => {
					document.getElementById('slider').value = this.get('sliderValue');
				}, 1);

				listeners.screenWidthListener(this);
			}
		},
		isMonthIncrease (month) {
			let subscriptionBonuses = this.get('subscriptionBonuses');
			let currentMonthBonus = subscriptionBonuses[month - 1];

			if (month === 1) {
				return currentMonthBonus > this.get('donatedByMonth').reduce((a, b) => a + b, 0) / DOLLARS_FOR_BONUS * BONUS_PER_HUNDRED_DOLLARS;
			}

			return subscriptionBonuses.every((bonus, index) => {
				if (index === month - 1) {
					return true;
				}

				if (index < month - 1) {
					return bonus < currentMonthBonus;
				}

				return bonus >= currentMonthBonus;
			});
		},
		getOneTimeDonationLink (amount) {
			if (amount > MAXIMUM_ONE_TIME_DONATION) {
				return `mailto:d@globalping.io?subject=${encodeURIComponent(`Globalping sponsorship: $${amount}`)}&body=${encodeURIComponent(`Hi, I'd like to sponsor Globalping for ${amount} dollars in a single payment.`)}`;
			}

			return `https://github.com/sponsors/jsdelivr?frequency=one-time&amount=${amount}`;
		},
		formatNumber (number) {
			return number.toLocaleString('en-US');
		},
		handleSliderKeypress (e) {
			if (![ 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown' ].includes(e.code)) {
				return;
			}

			e.preventDefault();
			e.stopPropagation();

			let toDonate = this.get('toDonate');
			let changeMultiplier = toDonate > 100 ? Math.floor(Math.sqrt(toDonate)) / 5 : 1;

			if (e.code === 'ArrowLeft' || e.code === 'ArrowDown') {
				this.set('sliderValue', Math.max(Math.sqrt(toDonate - 5 * changeMultiplier), this.get('sliderMinimum')));
			} else if (e.code === 'ArrowRight' || e.code === 'ArrowUp') {
				this.set('sliderValue', Math.min(Math.sqrt(toDonate + 5 * changeMultiplier), this.get('sliderMaximum')));
			}
		},
		roundSliderValue () {
			let roundedDonation = Math.round(Math.pow(this.get('sliderValue'), 2) / 5) * 5;
			this.set('sliderValue', Math.sqrt(roundedDonation));
		},
		handlePaymentTypeInputClick (event) {
			event.preventDefault();
			this.handlePaymentTypeSwitch(!this.get('oneTimeChecked'));
		},
		handlePaymentTypeInputKeyDown (event) {
			if (event.key === ' ' || event.key === 'Enter') {
				event.preventDefault();
				this.handlePaymentTypeSwitch(!this.get('oneTimeChecked'));
			}
		},
		handlePaymentTypeLabelClick (event) {
			event.preventDefault();
		},
		handlePaymentTypeSwitch (oneTimeChecked) {
			this.set('oneTimeChecked', oneTimeChecked);
			this.find('#switch-payment-type')?.focus();
		},
	};
</script>
